(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/start.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/start.js');

'use strict';

svs.player_login.views.Start = Marionette.View.extend({
  template() {
    svs.core.template.updateConfig({
      hideBalanceBar: true
    });
    this.getTemplate();
  },
  getTemplate() {
    if (this.model.get('isCustomerRegistration')) {
      return svs.player_login.templates.player_registration;
    }
    return svs.player_login.templates.start;
  },
  behaviors: [svs.player_login.behaviors.About, svs.player_login.behaviors.Navigation]
});

 })(window);